import { useNewTranslation } from 'hooks'
import IconButton from 'particles/Button/IconButton'
import Icon from 'particles/Icon'
import Text from 'particles/Text'
import Tooltip from 'particles/Tooltip'
import styled from 'particles/themes/styled'
import React, { useEffect, useState } from 'react'
import { HELPDESK_URL, TOOLTIP_DOMAIN_EVENT, cancelTooltipEmitter, tooltipEmitter } from 'services/tooltipEmitter'

const Helpdesk = () => {
    const [visible, setVisible] = useState(false)
    const [t] = useNewTranslation()

    useEffect(() => {
        const showTooltip = () => setVisible(true)
        const hideTooltip = () => setVisible(false)

        tooltipEmitter.on(TOOLTIP_DOMAIN_EVENT.helpdesk.show, showTooltip)
        tooltipEmitter.on(TOOLTIP_DOMAIN_EVENT.helpdesk.close, hideTooltip)

        return () => {
            tooltipEmitter.off(TOOLTIP_DOMAIN_EVENT.helpdesk.show, showTooltip)
            tooltipEmitter.off(TOOLTIP_DOMAIN_EVENT.helpdesk.close, hideTooltip)
        }
    }, [])

    const handleClick = () => {
        setVisible(false)
        cancelTooltipEmitter()
        window.open(HELPDESK_URL, '_blank')
    }

    return (
        <StyledHelpdeskContainer tooltipVisible={visible}>
            <Tooltip label={visible ? undefined : t('profile.helpSupportSectionHeader')} placement="right">
                <IconButton
                    icon="question"
                    form="icon"
                    color="neutral"
                    onClick={handleClick}
                    className={visible ? 'hovered' : ''}
                />
            </Tooltip>

            <div className="tooltip">
                <div className="tooltip-title">
                    <Icon name="warningCircle" color="primaryInverse" size="20px" />
                    <Text color="primaryInverse" scale="bodyM500">
                        {t('educationTooltips.helpButtonGuide.title')}
                    </Text>
                </div>
                <Text color="primaryInverse" scale="bodyS400">
                    {t('educationTooltips.helpButtonGuide.subText')}
                </Text>
            </div>
        </StyledHelpdeskContainer>
    )
}

export default Helpdesk

const StyledHelpdeskContainer = styled.div<{ tooltipVisible: boolean }>`
    position: relative;

    .hovered {
        background: ${({ theme }) => theme.colors.surface.neutralActionSubPastelHover};
    }

    .tooltip {
        position: absolute;
        display: flex;
        flex-direction: column;
        gap: 10px;
        right: -230px;
        bottom: 0px;
        width: 220px;
        background: ${({ theme }) => theme.colors.indicator.skyBlue};
        border-radius: 7px;
        padding: 12px;
        box-sizing: border-box;
        transition:
            opacity 0.3s ease-in-out,
            visibility 0.3s ease-in-out;
        opacity: ${({ tooltipVisible }) => (tooltipVisible ? '1' : '0')};
        visibility: ${({ tooltipVisible }) => (tooltipVisible ? 'visible' : 'hidden')};

        .tooltip-title {
            display: flex;
            align-items: center;
            gap: ${({ theme }) => theme.spacing[100]};
        }
    }
`
